const localStorageKeyName = 'rci_pow_sess_ext_primary_tab_id';
const localStorageTimeStamp = 'rci_pow_sess_ext_prev_timestamp';
const myTabId = `${Math.random() * 1000000000}`;
const timeInterval = window.weeksWebCloudConfig.SESSION_TIMEOUT;
let timeIntervalId;
let timeLockId;
/* const hasPrimaryTabExpired = (expiry) => {
  const pervTimeStamp = localStorage.getItem(localStorageKeyName)
  ? localStorage.getItem(localStorageKeyName).split('_t_')[1] : 0;
  if (parseInt(pervTimeStamp, 10) - performance.now() > expiry) {
    return true;
  }
  return false;
}; */
const extendSession = () => {
  fetch('/extend-session', { method: 'GET' });
};
const handleSessionExtend = () => {
  const timeStamp = Date.now();
  // console.log('--------------extend tab id========', myTabId);
  const pervTimeStamp = localStorage.getItem(localStorageTimeStamp) || (timeStamp - (timeInterval * 60 * 1000));
  const timeElapsedFromLastExtension = timeStamp - parseInt(pervTimeStamp, 10);
  let firstExtensionInteval = timeInterval * 60 * 1000;
  if (timeElapsedFromLastExtension >= (timeInterval * 60 * 1000)) {
    localStorage.setItem(localStorageKeyName, myTabId);
    extendSession();
    localStorage.setItem(localStorageTimeStamp, timeStamp);
  } else {
    firstExtensionInteval = (timeInterval * 60 * 1000) - timeElapsedFromLastExtension;
  }
  setTimeout(() => {
    localStorage.setItem(localStorageKeyName, myTabId);
    setTimeout(() => {
      if (localStorage.getItem(localStorageKeyName) === myTabId) {
        extendSession();
        localStorage.setItem(localStorageTimeStamp, timeStamp);
      }
    }, 10000);
  }, firstExtensionInteval);
};
export default handleSessionExtend;

const setLoopAfterSync = () => {
  timeIntervalId = setTimeout(() => {
    localStorage.setItem(localStorageKeyName, myTabId);
    timeLockId = setTimeout(() => {
      if (localStorage.getItem(localStorageKeyName) === myTabId) {
        extendSession();
        localStorage.setItem(localStorageTimeStamp, Date.now());
      }
    }, 10000);
  }, (timeInterval * 60 * 1000));
};
window.addEventListener('storage', (event) => {
  if (event.key !== localStorageTimeStamp) return; // ignore other keys
  if (!event.newValue) return;
  clearTimeout(timeIntervalId);
  clearTimeout(timeLockId);
  setLoopAfterSync();
});
